import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { GlobalDataContextService_FetchGQL } from 'src/graphql/generated/graphql.generated';
import { StoreService } from 'src/store/store.service';

@Injectable({ providedIn: 'root' })
export class GlobalDataContextService {
  constructor(private _store: StoreService, private _gql: GlobalDataContextService_FetchGQL) {}
  public fetch(): Observable<any> {
    return this._store.upsertEntitiesFromGraphQL(this._gql, undefined, {
      fetchPolicy: 'cache-first',
    });
  }

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.fetch();
  }
}
